import { ReactElement } from 'react'
import { K_C_90_OPTIONS } from '@domainConstants'
import { Select } from '@ui/forms'
import { compactFieldSx } from '../constants'

/**
 * kc,90 staged for every support of every selected member. `fullWidth` on top
 * of the app Select's own default-fullWidth FormControl: the FormControl being
 * fullWidth alone doesn't stretch the inner MuiSelect, which otherwise stays
 * at its own content size and leaves the FormControl's extra space empty.
 * Fills whatever width its field block (see SupportCompressionFields) gives it.
 */
const SharedSupportKC90Field = (): ReactElement => (
  <Select
    name="sharedSettings.k_c_90"
    options={K_C_90_OPTIONS}
    fullWidth
    sx={compactFieldSx}
    data-cy="support-compression-kc90"
  />
)

export default SharedSupportKC90Field
